import { useContext } from 'react';

import LocationContext from '../../contexts/LocationContext';

export default function useLocation() {
  return useContext(LocationContext);
}
